import { render } from "./dpp-photonav.vue?vue&type=template&id=6fad1725"
import script from "./dpp-photonav.js?vue&type=script&lang=js"
export * from "./dpp-photonav.js?vue&type=script&lang=js"

import "./dpp-photonav.vue?vue&type=style&index=0&id=6fad1725&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__